import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import { DateTimePicker } from "@mui/x-date-pickers";

// ----------------------------------------------------------------------

RHFDateTimeField.propTypes = {
  name: PropTypes.string,
  max_value: PropTypes.string,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  date: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
};

export default function RHFDateTimeField({
  disabled = false,
  label,
  name,
  max_value,
  date,
  helperText,
  maxDate,
  minDate,
  ...other
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DateTimePicker
          sx={{
            zIndex: 99999999,
          }}
          maxDate={maxDate}
          minDate={minDate}
          disabled={disabled}
          {...field}
          label={label}
          value={field?.value && new Date(field?.value)}
          onChange={(v) => field.onChange(new Date(v))}
          slotProps={{
            textField: {
              helperText: (
                <span style={{ color: "red" }}>{error?.message}</span>
              ),
            },
          }}
        />
      )}
    />
  );
}
